module.exports = __webpack_public_path__ + "static/media/payment.ec863678.png";